import React from "react";
import styles from "./ArticleCard.module.scss";
import cardImage from "../../../assets/images/card-image.jpg";
import ShareIcon from "components/svgs/ShareIcon";

const ArticleCard = () => {
  return (
    <div className={styles.card} onClick={() => console.log("Card clicked.")}>
      <div className={styles.cardImage}>
        <img src={cardImage} alt="card" />
      </div>
      <div className={styles.cardBody}>
        <div className={styles.cardSubTitle} title="Interview with an Artist">
          Interview with an Artist
        </div>
        <div
          className={styles.cardTitle}
          title="The Title Of The Article"
          onClick={(e) => e.stopPropagation()}
        >
          The Title Of The Article
        </div>
        <div className={styles.cardFooter}>
          <div className={styles.fullname} title="John Doe">
            John Doe
          </div>
          <div className={styles.date}>18 Aug, 2024</div>
          <div className={styles.share} onClick={(e) => e.stopPropagation()}>
            <ShareIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleCard;
